import { AuthAdapter } from './authAdapter'
import { FirebaseAuthAdapter } from './firebaseAdapter'
import { LocalOtpAuthAdapter } from './localOtpAdapter'

/**
 * Check if Firebase is configured in environment variables
 */
export function isFirebaseConfigured(): boolean {
  return !!(
    process.env.NEXT_PUBLIC_FIREBASE_API_KEY &&
    process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN &&
    process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID
  )
}

let authAdapterInstance: AuthAdapter | null = null

/**
 * Get the appropriate auth adapter based on environment configuration
 * Uses Firebase adapter if Firebase is configured, otherwise uses Local OTP adapter
 */
export function getAuthAdapter(): AuthAdapter {
  if (!authAdapterInstance) {
    if (isFirebaseConfigured()) {
      console.log('🔥 Using Firebase Authentication Adapter (client-side)')
      authAdapterInstance = new FirebaseAuthAdapter()
    } else {
      console.log('🔧 Using Local OTP Authentication Adapter (backend API)')
      authAdapterInstance = new LocalOtpAuthAdapter()
    }
  }
  return authAdapterInstance
}

/**
 * Reset the adapter instance (useful for testing or when switching modes)
 */
export function resetAuthAdapter(): void {
  authAdapterInstance = null
}

